export default __webpack_public_path__ + "static/media/Rectangle 5 (1).c75b5071.png";